import qs from "qs";
import axios from "axios";
import { API_URL } from "../../../../constants/Constants";

/**
 * Obtiene las MOs activas (no anuladas ni terminadas) con sus fechas de procesos
 * @returns {Promise<Array|false>} Array de MOs con fechas o false si hay error
 */
export const getActiveMosWithProcessDates = async () => {
  const queryData = {
    screen: "process_alert",
    action: "get_process_alert",
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    console.log("response", response.data);
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("No se pudieron obtener las MOs");
      return false;
    }
  } catch (error) {
    console.error("Error al obtener MOs con fechas de procesos:", error);
    return false;
  }
};

/**
 * Marca un proceso como realizado para una MO específica
 * @param {string} mo - Código de la MO
 * @param {string} po - Código de la PO (Purchase Order)
 * @param {string} processCode - Código del proceso (A, B, C, etc.)
 * @param {string} procesoOriginal - Proceso original según PROCESS_MATCHING (ej: "Clasif", "ASIGNAR", etc.)
 * @param {string} fechaActual - Fecha actual en formato ISO
 * @param {string} userName - Nombre del usuario que marca el proceso
 * @param {string} userTeam - Team del usuario que marca el proceso
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const markProcessAsCompleted = async (mo, po, processCode, procesoOriginal, fechaActual, userName, userTeam) => {
  const queryData = {
    screen: "process_alert",
    action: "mark_completed",
    mo: mo,
    po: po || "",
    process_code: processCode,
    proceso_original: procesoOriginal,
    fecha: fechaActual,
    usuario: userName,
    team: userTeam,
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      // Devolver toda la respuesta para acceder a status y message
      return {
        status: response.data.status,
        message: response.data.message,
        data: response.data.data
      };
    } else {
      console.log("No se pudo marcar el proceso como completado");
      return {
        status: "error",
        message: response.data.message || "No se pudo marcar el proceso como completado"
      };
    }
  } catch (error) {
    console.error("Error al marcar proceso como completado:", error);
    return {
      status: "error",
      message: "Ocurrió un error al marcar el proceso como completado"
    };
  }
};

